export const SCHEDULE_LOADING = 'SCHEDULE_LOADING'
export const SCHEDULE_SUCCESS = 'SCHEDULE_SUCCESS'
export const SCHEDULE_ERROR = 'SCHEDULE_ERROR'
export const SET_DATES = 'SET_DATES'
export const APPEND_TIMESLOT = 'APPEND_TIMESLOT'
export const SELECT_TIMESLOT = 'SELECT_TIMESLOT'
export const RESET_TIMESLOTS = 'RESET_TIMESLOTS'
export const INCREASE_MONTH = 'INCREASE_MONTH'
export const DECREASE_MONTH = 'DECREASE_MONTH'
export const CANCEL_FROM_UPCOMING_VISIT = 'CANCEL_FROM_UPCOMING_VISIT'
